@let searchFilters = filters();
@let searchPage = currentPage();
@let searchQuery = query() ?? '';
@let searchResults = result();

@if (searchResults) {
    <div class="container mt-20 mb-16 md:mt-20 lg:mt-30">
        <big-ui-breadcrumb
            class="sr-only mb-[2.125rem] md:mb-[4.625rem]"
            [entries]="breadcrumb()" />

        <div class="grid grid-cols-12 lg:gap-8">
            <div class="col-span-12 lg:col-span-10">
                @if (searchQuery) {
                    <h1 class="mb-10">
                        {{ resultsForText() }}
                    </h1>
                }
                @if (searchFilters && searchFilters.length && displayPagination()) {
                    <div class="bg-primary-500 dark:bg-primary-400 rounded-2xl p-6 mb-16 md:mb-20 lg:mb-30">
                        <big-ui-result-filter
                            [title]="resultFilterText()"
                            [hideTitle]="true"
                            [filter]="searchFilters"
                            [variant]="'dark'"
                            (activeFilter)="updateActiveFilter($event)" />
                    </div>
                }

                <big-search-result
                    [result]="searchResults"
                    [searchTerm]="searchQuery"
                    [currentPage]="searchPage" />
            </div>
        </div>
    </div>

    @if (searchResults.total > 0 && displayPagination()) {
        <big-ui-pagination
            [currentPage]="searchPage"
            [pageSize]="limit"
            [totalItems]="searchResults.total"
            (pageChange)="onPageChange($event)"
            class="mt-6" />
    } @else if (!displayPagination() && searchResults.total > 0) {
        <big-search-result
            [result]="emptySearchResult()"
            [searchTerm]="searchQuery"
            [currentPage]="searchPage" />
    }
}
